import styled, { css } from 'styled-components';
import type { SpaceProps, ColorProps, LayoutProps, PositionProps } from 'styled-system';
import { color, space, layout, position } from 'styled-system';
export type BoxProps = SpaceProps & ColorProps & LayoutProps & PositionProps;

const boxStyles = css`
  ${color}
  ${space}
  ${layout}
  ${position}
`;

const Box = styled.div<BoxProps>`
  ${boxStyles}
`;

export default Box;
